import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css' // 引入Element UI的样式文件

Vue.use(ElementUI)
Vue.config.productionTip = false
// 创建事件总线
Vue.prototype.$bus = new Vue();

import axios from 'axios';
Vue.prototype.$http = axios.create({
    baseURL: ' ',
    timeout: 5000, // 设置超时时间，根据需要调整
    headers: {
        'Content-Type': 'application/json'
    }
});
// 将 axios 挂载到 Vue 原型上
Vue.prototype.$axios = axios;

// 请求拦截器
Vue.prototype.$http.interceptors.request.use(
  function (config) {
    // 在这里可以添加请求头信息等操作，例如添加一个自定义的请求头
    config.headers['X-Custom-Header'] = 'SomeValue';
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// 响应拦截器
Vue.prototype.$http.interceptors.response.use(
  function (response) {
    // 可以在这里对响应数据进行处理，比如直接返回 data 部分（如果后端返回的数据结构符合一定规范）
    return response.data;
  },
  function (error) {
    // 更细致地处理响应错误，比如区分不同状态码进行不同处理
    if (error.response) {
      console.error('后端返回错误状态码，详细信息:', error.response.data);
    } else if (error.request) {
      console.error('请求未收到响应，可能是网络问题');
    } else {
      console.error('请求配置出现错误:', error.message);
    }
    return Promise.reject(error);
  }
);



new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
